import { gql } from '@apollo/client';

export const BATCH_SAVE_SORTER_PLAN_DWS_CHUTES = gql`
  mutation BatchSaveSorterPlanDwsChutes($input: SaveDwsChuteConfigsInput!) {
    batchSaveSorterPlanDwsChutes(input: $input)
  }
`;

export interface DwsChuteConfigInput {
  id?: number;
  chuteCode: string;
  chuteType: string;
  isOverspecification?: boolean;
  isNone: boolean;
  sortingCodes?: string;
}

export interface SaveDwsChuteConfigsInput {
  sorterPlanId: number;
  exceptionChuteCode?: string;
  chuteConfigs: DwsChuteConfigInput[];
  operateType?: number; // 1-仅保存，2-保存并选中
}

export interface BatchSaveSorterPlanDwsChutesData {
  batchSaveSorterPlanDwsChutes: boolean;
}

export interface BatchSaveSorterPlanDwsChutesVariables {
  input: SaveDwsChuteConfigsInput;
}
